/* eslint-disable @typescript-eslint/no-explicit-any */
import {CONSTANTS} from '../constants/constants';
import {HttpMethod, httpClient} from './httpClient';

export const getReferenceData = (): Promise<any> => {
  return httpClient('/subscriber/referencedata', HttpMethod.Get, null, CONSTANTS.SERVICE_TYPES.SUBSCRIBERS);
};